(function($){
	const SELECTOR = '.js-tooltip';
	const OFFSET = 10; // отступ подсказки от триггера
	const EDGE = 8; // минимальный отступ подсказки от края экрана
	const ARROW_EDGE = 14; // минимальный отступ стрелки от угла подсказки
	const MAX_WIDTH = 280;

	$(document).ready(()=>{
		// на десктопе показываем по наведению, на тач-устройствах — по клику
		const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

		const $tooltip = $(
			'<div class="tooltip" role="tooltip" aria-hidden="true">' +
				'<span class="tooltip__text"></span>' +
				'<span class="tooltip__arrow"></span>' +
			'</div>'
		).appendTo('body');
		const $text = $tooltip.find('.tooltip__text');
		const $arrow = $tooltip.find('.tooltip__arrow');

		let $current = null;

		function getText($trigger) {
			// нативная подсказка браузера дублирует свою — переносим её в data-title
			if ($trigger.attr('title')) {
				$trigger.attr('data-title', $trigger.attr('title')).removeAttr('title');
			}

			return $trigger.attr('data-title') || '';
		}

		function place() {
			if (!$current) return;

			const trigger = $current[0].getBoundingClientRect();
			const viewportWidth = document.documentElement.clientWidth;
			const viewportHeight = document.documentElement.clientHeight;

			$tooltip.css({
				'max-width': Math.min(MAX_WIDTH, viewportWidth - EDGE * 2) + 'px',
				'left': 0,
				'top': 0
			});

			const width = $tooltip.outerWidth();
			const height = $tooltip.outerHeight();

			// по умолчанию снизу, но если снизу не помещается, а сверху есть место — показываем сверху
			const noSpaceBelow = trigger.bottom + OFFSET + height > viewportHeight;
			const isAbove = noSpaceBelow && trigger.top - OFFSET - height > 0;
			const top = isAbove ? trigger.top - OFFSET - height : trigger.bottom + OFFSET;

			// центрируем по триггеру, но не даём выехать за края экрана
			const center = trigger.left + trigger.width / 2;
			const maxLeft = Math.max(EDGE, viewportWidth - width - EDGE);
			const left = Math.min(Math.max(center - width / 2, EDGE), maxLeft);

			// стрелка остаётся напротив триггера даже после сдвига подсказки
			const arrowLeft = Math.min(Math.max(center - left, ARROW_EDGE), width - ARROW_EDGE);

			$tooltip
				.toggleClass('tooltip--above', isAbove)
				.css({'left': left + 'px', 'top': top + 'px'});
			$arrow.css('left', arrowLeft + 'px');
		}

		function show($trigger) {
			const text = getText($trigger);
			if (!text) return;

			$current = $trigger;
			$text.text(text);
			$tooltip.addClass('tooltip--visible').attr('aria-hidden', 'false');
			place();
		}

		function hide() {
			if (!$current) return;

			$current = null;
			$tooltip.removeClass('tooltip--visible').attr('aria-hidden', 'true');
		}

		if (canHover) {
			$(document)
				.on('mouseenter focusin', SELECTOR, function(){
					show($(this));
				})
				.on('mouseleave focusout', SELECTOR, hide);
		}

		$(document).on('click', SELECTOR, function(e){
			// карточка товара целиком кликабельна — не даём уйти на страницу товара
			e.preventDefault();
			e.stopPropagation();

			if (canHover) return;

			const $trigger = $(this);

			if ($current && $current[0] === $trigger[0]) {
				hide();
				return;
			}

			show($trigger);
		});

		$(document).on('click', hide);

		$(document).on('keyup', (e)=>{
			if (e.key === 'Escape' || e.key === 'Esc') hide();
		});

		$(window).on('resize orientationchange', place);

		// true — чтобы ловить прокрутку и во вложенных скролл-контейнерах
		document.addEventListener('scroll', place, true);
	});
	// eslint-disable-next-line no-undef
})(jQuery);
